type ClickOutsideParams = {
	action: () => void;
	excludedRefs?: any[];
	disabled?: boolean;
};

export const clickOutside = (
	node: any,
	{ action, excludedRefs, disabled }: ClickOutsideParams = {
		action: () => {},
		excludedRefs: undefined,
		disabled: false
	}
) => {
	const handleClick = (event: any) => {
		if (disabled) return;

		const isExcluded = excludedRefs?.some((element: HTMLElement) =>
			element?.contains?.(event.target)
		);

		if (node?.contains && !isExcluded && !node.contains(event.target) && !event.defaultPrevented) {
			action();
		}
	};

	document.addEventListener('click', handleClick, true);

	return {
		update(params: ClickOutsideParams) {
			excludedRefs = params.excludedRefs;
			disabled = params.disabled;
		},
		destroy() {
			document.removeEventListener('click', handleClick, true);
		}
	};
};
